import { parentRequestModalActionTypes } from './Constants';

const initialState = {
	loading: false,
	isPackagesLoading: false,
	open: false,
	packages: [],
	selectedPackageId: null,
	selectedPackageName: null,
};

export default function parentRequestModalReducer(state = initialState, action) {
	const { type, payload } = action;
	const { open, data, packages, selectedId } = payload || {};

	switch (type) {
		case parentRequestModalActionTypes.TOGGLE_PARENT_REQUEST_MODAL:
			const options = open
				? { open: true }
				: {
						error: '',
						loading: false,
						isPackagesLoading: false,
						open: false,
						packages: [],
						selectedPackageId: null,
						selectedPackageName: null,
				  };
			return {
				...state,
				...options,
			};

		case parentRequestModalActionTypes.HANDLE_PARENT_REQUEST_MODAL:
			const paidPackages = packages.filter((item) => item.price);
			const availablePackagesData = paidPackages.map(
				({ id, name, price, discounted_price, preferred_plan_id }) => ({
					id,
					name,
					price,
					discounted_price,
					preferred_plan_id,
				}),
			);

			return {
				...state,
				open: true,
				packages: availablePackagesData,
				selectedPackageId: selectedId,
			};

		case parentRequestModalActionTypes.SET_PACKAGE_NAME:
			return {
				...state,
				...data,
			};

		case parentRequestModalActionTypes.GET_AVAILABLE_PACKAGES_SUCCESS:
			const packagesData = data
				.filter((item) => item.price)
				.map(({ id, name, price, discounted_price, preferred_plan_id, highlight }) => ({
					id,
					name,
					price,
					discounted_price,
					preferred_plan_id,
					highlight,
				}));

			return {
				...state,
				packages: packagesData,
				isPackagesLoading: false,
			};

		case parentRequestModalActionTypes.PARENT_PAYMENT_REQUEST:
		case parentRequestModalActionTypes.WHATSAPP_SHARE_REQUEST:
			return {
				...state,
				loading: true,
			};

		case parentRequestModalActionTypes.PARENT_PAYMENT_SUCCESS:
		case parentRequestModalActionTypes.PARENT_PAYMENT_ERROR:
		case parentRequestModalActionTypes.WHATSAPP_SHARE_ERROR:
			return {
				...state,
				loading: false,
			};

		case parentRequestModalActionTypes.GET_AVAILABLE_PACKAGES_REQUEST:
			return {
				...state,
				isPackagesLoading: true,
			};

		default:
			return state;
	}
}
